import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, ShieldCheck, Check } from 'lucide-react';
const valueItems = [{
  text: 'Endocrinologist consultation',
  price: '$350+'
}, {
  text: 'Registered dietitian (4 sessions)',
  price: '$600+'
}, {
  text: 'CGM coaching program',
  price: '$200/mo'
}, {
  text: 'Metabolic blood panel',
  price: '$150+'
}];
export function PriceAnchor() {
  return <section className="w-full py-24 px-4 bg-[#161616] border-t border-gray-800" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-141">
          {/* Value Stack */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6 md:space-y-8" data-id="element-142">
            <h2 className="text-2xl md:text-3xl font-bold text-white uppercase tracking-wide" data-id="element-143">
              The Cost of <span className="text-accent" data-id="element-144">Ignoring</span> The
              Problem
            </h2>

            <div className="space-y-3 md:space-y-4" data-id="element-145">
              {valueItems.map((item, index) => <div key={index} className="flex justify-between items-center p-3 md:p-4 bg-gray-900/50 rounded-lg border border-gray-800" data-id="element-146">
                  <div className="flex items-center gap-2 md:gap-3 min-w-0" data-id="element-147">
                    <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 flex-shrink-0" data-id="element-148">
                      <DollarSign className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-149" />
                    </div>
                    <span className="text-gray-300 font-medium text-sm md:text-base truncate" data-id="element-150">
                      {item.text}
                    </span>
                  </div>
                  <span className="text-gray-500 line-through font-mono text-sm md:text-base flex-shrink-0 ml-2" data-id="element-151">
                    {item.price}
                  </span>
                </div>)}

              <div className="flex justify-between items-center p-4 md:p-6 bg-gray-800/50 rounded-lg border border-gray-700 mt-3 md:mt-4" data-id="element-152">
                <span className="text-gray-400 uppercase tracking-widest text-xs md:text-sm font-bold" data-id="element-153">
                  Total Value
                </span>
                <span className="text-gray-400 line-through font-bold text-lg md:text-xl" data-id="element-154">
                  $1,300+
                </span>
              </div>
            </div>

            <div className="pt-2 md:pt-4 text-center md:text-left" data-id="element-155">
              <p className="text-gray-400 mb-2 uppercase tracking-widest text-xs md:text-sm font-bold" data-id="element-156">
                Your Investment Today:
              </p>
              <div className="flex items-baseline gap-3 md:gap-4 justify-center md:justify-start" data-id="element-157">
                <span className="text-gray-500 line-through text-2xl md:text-3xl font-bold" data-id="element-158">
                  $47
                </span>
                <span className="text-5xl md:text-6xl font-bold text-accent" data-id="element-159">
                  $6.36
                </span>
              </div>
              <div className="mt-3 md:mt-4 inline-flex items-center gap-2 bg-green-900/30 border border-green-800/40 rounded-lg px-3 md:px-4 py-2" data-id="element-160">
                <Check className="w-4 h-4 md:w-5 md:h-5 text-green-500 flex-shrink-0" data-id="element-161" />
                <span className="text-green-400 font-bold text-sm md:text-lg" data-id="element-162">
                  You save $40.64 (86% OFF)
                </span>
              </div>
              <p className="text-gray-500 text-xs md:text-sm mt-2" data-id="element-163">
                One-time payment • Limited time offer
              </p>
            </div>
          </motion.div>

          {/* Guarantee Box */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-900 border-2 border-accent/30 rounded-xl p-6 md:p-10 relative overflow-hidden" data-id="element-164">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-165">
              <ShieldCheck className="w-24 md:w-32 h-24 md:h-32 text-accent" data-id="element-166" />
            </div>

            <div className="relative z-10 space-y-4 md:space-y-6" data-id="element-167">
              <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-accent/10 flex items-center justify-center border border-accent/30 mb-3 md:mb-4" data-id="element-168">
                <ShieldCheck className="w-6 h-6 md:w-8 md:h-8 text-accent" data-id="element-169" />
              </div>

              <h3 className="text-xl md:text-2xl font-bold text-white uppercase tracking-wide" data-id="element-170">
                60-Day Ironclad Guarantee
              </h3>

              <p className="text-gray-300 leading-relaxed text-sm md:text-base" data-id="element-171">
                Follow the protocol for 60 days. If your next A1C reading
                doesn't improve, email us and we will refund every penny.
              </p>

              <p className="text-gray-300 leading-relaxed font-medium text-sm md:text-base" data-id="element-172">
                No questions. No hassle. The risk is entirely on us.
              </p>

              <div className="pt-2 md:pt-4 flex items-center gap-2 text-xs md:text-sm text-accent font-bold uppercase tracking-wider" data-id="element-173">
                <Check className="w-4 h-4" data-id="element-174" />
                <span data-id="element-175">100% Money Back Promise</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}